
import { computed, defineComponent } from 'vue';
import AddIcon from '@/components/ui-elements/icons/AddIcon.vue';
import BudgetEditTotal from '@/components/partials/BudgetEditTotal.vue';
import Button from '@/components/ui-elements/form/Button.vue';
import SaveIcon from '@/components/ui-elements/icons/SaveIcon.vue';
import useTimestamp from '@/hooks/useTimestamp';
import useUtils from '@/hooks/useUtils';
import { BudgetExpense } from '@/store/budget';
import useCurrency from '@/hooks/useCurrency';

export default defineComponent({
	components: {
		AddIcon,
		BudgetEditTotal,
		Button,
		SaveIcon,
	},
	props: {
		date: {
			required: true,
			type: String,
		},
		disableSave: {
			default: true,
			type: Boolean,
		},
		expenses: {
			required: true,
			type: Object as () => Record<string, Array<BudgetExpense>>,
		},
	},
	setup(props, { emit }) {
		const { formatDollar } = useCurrency();
		const { formatDate } = useTimestamp();
		const { arrayColumn } = useUtils();
		const cycle = formatDate('MMM yyyy', props.date);

		const generateTotals = (list: Array<BudgetExpense>) => {
			const amounts = arrayColumn('amount', list as any);
			return formatDollar(
				amounts.reduce((acc, cir) => acc + Number(cir), 0)
			);
		};

		const totalBanked = computed(() =>
			generateTotals(props.expenses['banks'] ?? '0.00')
		);
		const totalEarned = computed(() =>
			generateTotals(props.expenses['incomes'] ?? '0.00')
		);
		const totalInvested = computed(() =>
			generateTotals(props.expenses['investments'] ?? '0.00')
		);
		const totalSpent = computed(() => {
			const spentList: Array<BudgetExpense> = [];
			Object.keys(props.expenses)
				.filter(
					type => !['banks', 'incomes', 'investments'].includes(type)
				)
				.forEach(key => {
					const list = props.expenses[key].filter(expense => {
						if (typeof expense.not_track_amount !== 'undefined') {
							return !expense.not_track_amount;
						}

						return true;
					});

					spentList.push(...list);
				});

			return generateTotals(spentList);
		});
		const totalSaved = computed(() => {
			return formatDollar(
				(
					Number(totalEarned.value.replace(',', '')) -
					Number(totalSpent.value.replace(',', ''))
				).toString()
			);
		});

		return {
			addExpense: () => emit('add-expense'),
			cycle,
			isGain: computed(() => !totalSaved.value.includes('-')),
			saveBudget: () => emit('save-budget'),
			totalBanked,
			totalEarned,
			totalInvested,
			totalSaved,
			totalSpent,
		};
	},
});
